import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useContext, useMemo } from 'react';

import HOSTS from '@/constants/hosts';
import { JOTFORM_SUPPORT_URL } from '@/constants/jotform';
import AppContext from '@/contexts/appContext';

import { Props } from './types';

const SupportLink = ({
  icon = faQuestionCircle,
  linkText = 'Tech Support',
  originUrl,
  params
}: Props) => {
  const { currentUser, host } = useContext(AppContext);

  const buildSupportURL = useCallback(
    ({ email, host, url }: { email: string; host: string; url: string }) => {
      const urlParams = new URLSearchParams({
        dugoutURL: url,
        email,
        source: 'dugout',
        environment: host === HOSTS.production ? 'prod' : 'staging',
        ...(originUrl && { websiteURL: originUrl }),
        ...params
      });

      return `${JOTFORM_SUPPORT_URL}?${urlParams.toString()}`;
    },
    [originUrl, params]
  );

  const href = useMemo(() => {
    return buildSupportURL({
      email: currentUser?.email || '',
      host,
      url: window.location.href
    });
  }, [buildSupportURL, currentUser?.email, host]);

  return (
    <a href={href} target="_blank" rel="noreferrer nofollow">
      <FontAwesomeIcon className="mr-2" icon={icon} />
      {linkText}
    </a>
  );
};

export default SupportLink;
